import type { FC } from 'react'
import { useContext } from 'react'
import styled from 'styled-components'

import { Button, AlternateButton } from '@/components/DEPRECATED_UI/Button'
import SlideInSidebar from '@/components/DEPRECATED_UI/SlideInSidebar'
import ctx from '@/context/AppContext'
import { toErrorNode, useUnableToVerifyAddressMutation } from '@/lib/apollo'

const ContentContainer = styled.div`
  display: grid;
  gap: 20px;
`

interface Props {
  customerId: string
  subjectId: string
  onClose: () => void
}

const UnableToVerifySidebar: FC<Props> = ({ customerId, subjectId, onClose }) => {
  const [unableToVerifyAddress, { data, loading, error }] =
    useUnableToVerifyAddressMutation()

  const { personId } = useContext(ctx)

  const handleSubmit = () =>
    unableToVerifyAddress({
      variables: {
        customerId,
        subjectId,
        userId: personId ?? '',
      },
    })

  return (
    <SlideInSidebar
      onClose={onClose}
      header={<h1>Unable to verify</h1>}
      content={
        <>
          <p>If you were unable to verify this address, please click confirm below.</p>
          <ContentContainer>{toErrorNode(error)}</ContentContainer>
        </>
      }
      footer={
        <div className="side-by-side-flex-end">
          <AlternateButton onClick={onClose}>Cancel</AlternateButton>
          {!data && (
            <Button disabled={loading} onClick={handleSubmit}>
              Confirm
            </Button>
          )}
        </div>
      }
    />
  )
}

export default UnableToVerifySidebar
